import React, { useEffect, useRef, useState } from "react";
import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";
import "./AchievementsSection.css";

const certificates = [
  {
    title: "Membership Certificate – IEI",
    image: "/assets/images/Certificates/certificate1.jpg",

  },
  {
    title: "Chartered Engineer [India]",
    image: "/assets/images/Certificates/certificate2.jpg",

  },
  {
    title: "ISO 9001:2015 Certification",
    image: "/assets/images/Certificates/certificate3.jpg",

  },
  {
    title: "Indian Achievers Award 2021",
   image: "/assets/images/Certificates/certificate4.jpg",
  },
];

const AchievementsSection = () => {
  const [active, setActive] = useState(0);
  const [modal, setModal] = useState(null);
  const intervalRef = useRef(null);
  const touchStartX = useRef(null);

  /* ---------- AUTO SCROLL ---------- */
  const startAutoScroll = () => {
    intervalRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % certificates.length);
    }, 3000);
  };

  const stopAutoScroll = () => {
    clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoScroll();
    return () => stopAutoScroll();
  }, []);

  /* ---------- KEYBOARD NAV ---------- */
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowRight") {
        setActive((p) => (p + 1) % certificates.length);
      }
      if (e.key === "ArrowLeft") {
        setActive((p) => (p - 1 + certificates.length) % certificates.length);
      }
      if (e.key === "Escape") {
        setModal(null);
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  /* ---------- SWIPE (MOBILE) ---------- */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    const deltaX = touchStartX.current - e.changedTouches[0].clientX;
    if (deltaX > 50) {
      setActive((p) => (p + 1) % certificates.length);
    }
    if (deltaX < -50) {
      setActive((p) => (p - 1 + certificates.length) % certificates.length);
    }
  };

  return (
    <>
      <section
        className="intel-achievements"
        onMouseEnter={stopAutoScroll}
        onMouseLeave={startAutoScroll}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <h2 className="intel-heading">Our Certificates</h2>

        <div className="intel-carousel">
          {/* LEFT ARROW */}
          <button
            className="nav-btn left"
            onClick={() =>
              setActive(
                (p) => (p - 1 + certificates.length) % certificates.length
              )
            }
            aria-label="Previous"
          >
            <FiChevronLeft />
          </button>

          {/* CARDS */}
          <div className="cards-wrapper">
            {certificates.map((item, index) => {
              const offset = index - active;

              return (
                <div
                  key={index}
                  className="cert-card"
                  style={{
                    transform: `translateX(${offset * 320}px) scale(${
                      index === active ? 1 : 0.9
                    })`,
                    opacity: Math.abs(offset) > 2 ? 0 : 1,
                    zIndex: 10 - Math.abs(offset),
                    pointerEvents: "none", // 🔥 allows arrows to work
                  }}
                >
                  <div
                    className="cert-image-wrapper"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModal(item);
                    }}
                    style={{ pointerEvents: "auto" }} // 🔥 image still clickable
                  >
                    <img src={item.image} alt={item.title} />
                    <div className="cert-title">{item.title}</div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* RIGHT ARROW */}
          <button
            className="nav-btn right"
            onClick={() =>
              setActive((p) => (p + 1) % certificates.length)
            }
            aria-label="Next"
          >
            <FiChevronRight />
          </button>
        </div>

        {/* PROGRESS DOTS */}
        <div className="dots">
          {certificates.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === active ? "active" : ""}`}
              onClick={() => setActive(i)}
            />
          ))}
        </div>
      </section>

      {/* FULLSCREEN MODAL */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setModal(null)}
            >
              <FiX />
            </button>
            <img src={modal.image} alt={modal.title} />
            <h3>{modal.title}</h3>
          </div>
        </div>
      )}
    </>
  );
};

export default AchievementsSection;
